// Presentation rules only. This module must never be imported by calculators
// or used to change evidence, explanation wording, rankings or saved reports.
const supportedTypes = new Set(["land", "house_and_land"]);
const supportedGoals = new Set(["live_in", "invest"]);

export function eligiblePartners(config, { goal, propertyType }) {
  if (
    config?.version !== "partners-v1" ||
    !Array.isArray(config.partners) ||
    !supportedGoals.has(goal) ||
    !supportedTypes.has(propertyType)
  )
    return [];

  return config.partners
    .filter((partner) => {
      if (!partner || partner.enabled !== true) return false;
      if (!/^[a-z][a-z0-9-]{0,39}$/.test(partner.id || "")) return false;
      if (
        typeof partner.name !== "string" ||
        !partner.name.trim() ||
        partner.name.length > 100
      )
        return false;
      if (typeof partner.sameFounders !== "boolean") return false;
      if (partner.id === "r2" && partner.sameFounders !== true) return false;
      if (partner.scope !== "brisbane_pilot") return false;
      if (
        typeof partner.cta !== "string" ||
        partner.cta.length < 12 ||
        partner.cta.length > 120
      )
        return false;
      if (!["unconfirmed", "none", "paid"].includes(partner.remuneration))
        return false;
      if (
        partner.remuneration === "paid" &&
        (typeof partner.benefitDisclosure !== "string" ||
          !partner.benefitDisclosure.trim())
      )
        return false;
      if (
        !Array.isArray(partner.goals) ||
        !partner.goals.includes(goal) ||
        !partner.goals.every((item) => supportedGoals.has(item))
      )
        return false;
      if (
        !Array.isArray(partner.propertyTypes) ||
        !partner.propertyTypes.includes(propertyType) ||
        !partner.propertyTypes.every((item) => supportedTypes.has(item))
      )
        return false;
      try {
        const url = new URL(partner.website);
        if (
          url.protocol !== "https:" ||
          url.username ||
          url.password ||
          url.search ||
          url.hash
        )
          return false;
      } catch {
        return false;
      }
      return true;
    })
    .slice(0, 1);
}
